import * as Actions from '../Actions/EmpresaFinanceiroActions';
// import _ from '@lodash';

const initialState = {
    data: null,
    caixas: null,
    extrato: null,
    faturamento: null,
    detalhes: null,
    conta: null,
    info: null,
    warning: null,
    error: null,
};

const EmpresaFinanceiroReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAFINANCEIRO_APONTAMENTOS:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.GET_EMPRESAFINANCEIRO_CAIXAS:
            {
                return {
                    ...state,
                    caixas: action.payload,
                };
            }
        case Actions.GET_EMPRESAFINANCEIRO_CAIXA_NAORECEBIDO:
            {
                return {
                    ...state,
                    caixanaorecebido: action.payload,
                };
            }
        case Actions.GET_EMPRESAFINANCEIRO_EXTRATO:
            {
                return {
                    ...state,
                    extrato: action.payload,
                };
            }
        case Actions.GET_EMPRESAFINANCEIRO_FATURAMENTO:
            {
                return {
                    ...state,
                    faturamento: action.payload,
                };
            }
        case Actions.GET_EMPRESAFINANCEIRO_GRUPODETALHES:
            {
                return {
                    ...state,
                    detalhes: action.payload,
                };
            }
        case Actions.EMPRESAFINANCEIRO_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                };
            }
        case Actions.EMPRESAFINANCEIRO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        case Actions.EMPRESAFINANCEIRO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case Actions.GET_EMPRESAFINANCEIRO_CONTA:
            {
                return {
                    ...state,
                    conta: action.payload,
                };
            }
        case Actions.CLEAR_REDUCER:
            {
                return {
                    data: null,
                    caixas: null,
                    extrato: null,
                    faturamento: null,
                    detalhes: null,
                    conta: null,
                    info: null,
                    warning: null,
                    error: null,
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = EmpresaFinanceiroReducer;

export default reducer;